import { constants } from '..';

const INITIAL_STATE = {
  loading: false,
  templateDownloading: false,
  importValidating: false,
  importCommitting: false,
  importBatch: null,
  importCommitResult: null,
  total: 0,
  physicalCards: [],
  selectedCard: null,
  discountError: '',
  usage: [],
  usageTotal: 0,
};

export const physicalCardsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.physicalCards.SET_PHYSICAL_CARDS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS:
      return {
        ...state,
        physicalCards: action.physicalCards,
        total: action.count,
      };
    case constants.physicalCards.CLEAR_PHYSICAL_CARDS:
      return {
        ...INITIAL_STATE,
      };
    case constants.physicalCards.SET_PHYSICAL_CARD:
      return {
        ...state,
        selectedCard: action.selectedCard,
      };
    case constants.physicalCards.CLEAR_PHYSICAL_CARD:
      return {
        ...state,
        selectedCard: null,
        discountError: '',
      };
    case constants.physicalCards.SET_PHYSICAL_CARD_DISCOUNT_ERROR:
      return {
        ...state,
        discountError: action.error || '',
      };
    case constants.physicalCards.CLEAR_PHYSICAL_CARD_DISCOUNT_ERROR:
      return {
        ...state,
        discountError: '',
      };
    case constants.physicalCards.SET_PHYSICAL_CARD_USAGE:
      return {
        ...state,
        usage: action.usage,
        usageTotal: action.count,
      };
    case constants.physicalCards.CLEAR_PHYSICAL_CARD_USAGE:
      return {
        ...state,
        usage: [],
        usageTotal: 0,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS_TEMPLATE_DOWNLOADING:
      return {
        ...state,
        templateDownloading: action.flag,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_VALIDATING:
      return {
        ...state,
        importValidating: action.flag,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_BATCH:
      return {
        ...state,
        importBatch: action.importBatch,
        importCommitResult: null,
      };
    case constants.physicalCards.CLEAR_PHYSICAL_CARDS_IMPORT:
      return {
        ...state,
        importValidating: false,
        importCommitting: false,
        importBatch: null,
        importCommitResult: null,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_COMMITTING:
      return {
        ...state,
        importCommitting: action.flag,
      };
    case constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_COMMIT_RESULT:
      return {
        ...state,
        importCommitResult: action.importCommitResult,
      };
    default:
      return state;
  }
};
